export default "__VITE_ASSET__DMWuuseG__"